import { Dispatch } from 'react';
import * as CAction from './column.actionTypes';
import { ColumnProps } from '../types/board.types';
import BoardService from '../services/board.service';
import BoardConst from '../utils/constants/board';
import {
  constructAiAutomationData,
  mergeAiAutomationData,
  constructWsAutomationData,
  constructUserAutomationData,
  mergeUserAutomationData,
} from '../utils/board';
import { getActivityIssueTypesFilterOptions } from '../utils/ai.util';
import {
  reorderWithinColumnData,
  fullIndexOfVisibleItem,
  fullInsertIndexForVisibleIndex,
} from '../utils/columnVisibility';

import { updateTimleineTask, removeTimelineTask } from '../utils/timeline';
import { ACTIVITY_TYPE_ATTR_NAMES } from '../types/ai.types';

const boardSevice = new BoardService();

export const tempAddColumn = () => {
  const randNum = Math.floor(Math.random() * 10000000) + 1;
  const newColumn: ColumnProps = {
    id: `new_col_${randNum}`,
    title: '',
    c_name: '',
    color: '#184967',
    data: [],
  };
  return newColumn;
};

export const isNewColumnId = (id: string): boolean => typeof id !== undefined && id && id.indexOf('new_col_') !== -1;

export const addBoardColumn = () => (dispatch: Dispatch<CAction.ColumnActionTypes>) => {
  try {
    console.log('addBoardColumn');
    dispatch({
      type: CAction.BOARD_ADD_COLUMN,
      payload: tempAddColumn(),
    });
  } catch (e) {}
};

export const editBoardColumn =
  (columnId: string, payload: ColumnProps) => async (dispatch: Dispatch<CAction.ColumnActionTypes>, getState: any) => {
    try {
      console.log('edit boardColumn');
      console.log('getState, ', getState().boardDetails);
      const { boardDetails, boardView } = getState();
      const { board = {} } = boardDetails;
      let checkNewColumn = true;
      const params: any = {
        wsId: boardDetails.tagId,
        title: payload.title,
        boardId: board.id,
        object_type: boardView,
      };
      if (!isNewColumnId(columnId)) {
        params.id = columnId;
        checkNewColumn = false;
      }
      console.log('params', params);
      dispatch({
        type: CAction.BOARD_EDIT_COLUMN,
        columnId,
        payload,
      });
      const saveBoardColumn = await boardSevice.saveColumn(params);
      const responseData = saveBoardColumn.data;
      if (responseData.data) {
        dispatch({
          type: CAction.BOARD_EDIT_COLUMN,
          columnId,
          payload: responseData.data,
        });
      } else {
        console.log(responseData);
      }
      console.log('saveBoardColumn', saveBoardColumn);
      if (checkNewColumn) {
        const scrollLength = $('.boardSection').width() + 1000;
        $('.mainBoardWrapper').animate({ scrollLeft: scrollLength }, 200);
      }
    } catch (e) {}
  };

export const deleteBoardColumn = (columnId: string) => async (dispatch: Dispatch<CAction.ColumnActionTypes>) => {
  try {
    console.log('deleteBoardColumn');
    dispatch({
      type: CAction.BOARD_DELETE_COLUMN,
      columnId,
    });
    const deleteColumn = await boardSevice.deleteColumn({ id: columnId });
  } catch (e) {}
};

export const sortingBoardColumn =
  (source: any, destination: any, draggableId: string, action: string) =>
  (dispatch: Dispatch<CAction.ColumnActionTypes>, getState: any) => {
    try {
      const currentState = getState();
      const { boardDetails, boardView, boardFilters } = getState();
      const { board = {}, tagId, boardType } = boardDetails;
      let columns = Object.assign([], boardDetails.columns);
      let viewAiPane: any = boardDetails.viewAiPane || undefined;
      const isBoard = !!(typeof board !== 'undefined' && Object.keys(board).length);
      // Shared projection context so reordering maps rendered-list positions back
      // to the underlying (unfiltered) column data exactly as ColumnList renders
      // it. Prevents cards from jumping to the wrong slot when items are hidden
      // by a filter (MR-8165).
      const visibilityCtx = {
        boardView,
        boardType,
        boardFilters,
        issueTypeOptionsCount: getActivityIssueTypesFilterOptions().length,
      };
      if (action == 'column') {
        const project = boardDetails.columns[source.index];
        columns.splice(source.index, 1);
        columns.splice(destination.index, 0, project);
        const columnIds = columns.map((c: any) => c.id);
        console.log('columnIds', columnIds);
        dispatch({
          type: CAction.BOARD_REORDER_COLUMN,
          columns,
        });
        const entityId = boardView == '1' ? tagId : board.id;
        boardSevice.saveColumnSorting({ items: columnIds, entityId, boardView });
      } else if (action == 'column_item') {
        const board_id = destination.droppableId;
        let itemId = draggableId.split('-')[2];
        if (
          isBoard &&
          (board.type == BoardConst.BOARD_DATATYPE_WORKSTREAMS || board.type == BoardConst.BOARD_DATATYPE_PEOPLE)
        ) {
          itemId = draggableId.split('-')[3];
        }
        let columnIds: any = [];
        if (Array.isArray(columns)) {
          columns.forEach((c: any) => {
            if (c.id == destination.droppableId) {
              if (!isBoard) {
                // source.index / destination.index are positions in the rendered
                // (filtered) list; reorder in that projection and merge back so a
                // card lands exactly where it was dropped (MR-8165).
                c.data = reorderWithinColumnData(c.data, visibilityCtx, source.index, destination.index);
              } else {
                const { data } = c;
                const [cData] = data.splice(source.index, 1);
                data.splice(destination.index, 0, cData);
                c.data = data;
              }
              columnIds = c.data.map((d: any) => d.id);
            }
            return c;
          });
        }
        dispatch({
          type: CAction.BOARD_REORDER_COLUMN,
          columns,
        });
        if (tagId) {
          boardSevice.saveCustomSortingOrder({
            items: columnIds,
            tagId,
            board_type: boardType,
            board_id,
          });
        } else {
          boardSevice.saveUserWsFtSortingOrder({ items: columnIds, boardId: board.id, columnId: board_id });
        }
      } else if (action == 'column_move_item') {
        console.log('action', action);
        let columnIds: any = [];
        let destinationColumnIds: any = [];
        let itemId = draggableId.split('-')[2];
        if (
          isBoard &&
          (board.type == BoardConst.BOARD_DATATYPE_WORKSTREAMS || board.type == BoardConst.BOARD_DATATYPE_PEOPLE)
        ) {
          itemId = draggableId.split('-')[3];
        }
        let removedItem: any = null;
        console.log('itemId', itemId);

        // does some column exists
        if (Array.isArray(columns)) {
          // source column
          const sourceData = columns.find((c: any) => c.id == source.droppableId);

          // destination column
          const destinationData = columns.find((c: any) => c.id == destination.droppableId);

          // take and modify moved AI. source.index is the dragged item's
          // position in the rendered (filtered) source list; map it back to the
          // underlying array so the correct item is removed (MR-8165).
          const sourceIndex = !isBoard
            ? fullIndexOfVisibleItem(sourceData.data, visibilityCtx, source.index)
            : source.index;
          let [removed] = sourceData.data.splice(sourceIndex, 1);
          if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
            if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
              removed = {
                ...removed,
                state: destination.droppableId,
                stateText: destinationData.defaultTile,
                columnId: destination.droppableId,
              };
            } else {
              removed = {
                ...removed,
                board_column: destination.droppableId,
                columnId: destination.droppableId,
              };
            }
          } else {
            removed = { ...removed, board_column: destination.droppableId };
          }

          if (viewAiPane && viewAiPane.id == removed.id) {
            viewAiPane = removed;
          }

          removedItem = removed;
          // destination.index is a position in the rendered (filtered) destination
          // list; map it to the underlying array so the card lands where dropped.
          const destInsertIndex = !isBoard
            ? fullInsertIndexForVisibleIndex(destinationData.data, visibilityCtx, destination.index)
            : destination.index;
          destinationData.data.splice(destInsertIndex, 0, removed);

          // swaps the source and destination column
          columns.forEach((c: any) => {
            if (c.id == source.droppableId) {
              c.data = sourceData.data;
            }

            if (c.id == destination.droppableId) {
              c.data = destinationData.data;
            }

            // recalculate progress on subactions
            if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
              if (source.droppableId == '0' || destination.droppableId == '0') {
                c.data.map((par) => {
                  if (par.id == removed.parent) {
                    par.subCount.doneCount =
                      destination.droppableId == '0'
                        ? String((Number(par.subCount.doneCount) || 0) + 1)
                        : String(Number(par.subCount.doneCount) - 1);
                  }
                });
              }
            }

            return c;
          });

          columnIds = sourceData.data.map((d: any) => d.id);
          destinationColumnIds = destinationData.data.map((d: any) => d.id);

          if (tagId) {
            boardSevice.saveCustomSortingOrder({
              tagId,
              board_type: boardType,
              sourceId: source.droppableId,
              destinationId: destination.droppableId,
              sourceItems: columnIds,
              destinationItems: destinationColumnIds,
            });
          } else {
            boardSevice.saveUserWsFtSortingOrder({
              boardId: board.id,
              sourceId: source.droppableId,
              destinationId: destination.droppableId,
              sourceItems: columnIds,
              destinationItems: destinationColumnIds,
            });
          }
        }

        dispatch({
          type: CAction.BOARD_REORDER_COLUMN,
          columns,
          viewAiPane,
        });

        const newColumnId = destination.droppableId;
        const oldColumnId = source.droppableId;
        let timelineData: any = currentState.boardTimeline || null;
        if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
          if (boardType == BoardConst.WS_BOARD_TYPE_CUSTOM) {
            boardSevice
              .changeColumn({
                act_id: itemId,
                boardType: '',
                newColumn: destination.droppableId,
                oldColumn: source.droppableId,
                tagId,
              })
              .then((response) => {
                const boardData: any = constructAiAutomationData(response.data.response);
                console.log('boardData', boardData);
                if (Object.keys(boardData).length) {
                  columns = columns.map((c: any) => {
                    if (c.id == newColumnId) {
                      c.data = c.data.map((d: any) => {
                        if (d.id == itemId) {
                          let processingTask = false;
                          if (typeof boardData.state !== undefined) {
                            if (d.state == '1' && boardData.state != '1') {
                              processingTask = true;
                              timelineData = removeTimelineTask(currentState, d.id);
                            } else if (!processingTask && d.state != '1' && boardData.state == '1') {
                              processingTask = true;
                              timelineData = updateTimleineTask(currentState, d);
                            }
                          }
                          if (typeof boardData.owner !== undefined) {
                            if (!processingTask && boardData.owner != d.onwer && d.state == '1') {
                              timelineData = updateTimleineTask(currentState, d, d.owner);
                            }
                          }
                          d = mergeAiAutomationData(d, boardData);
                          console.log('modified data', d);
                          if (viewAiPane && viewAiPane.id == d.id) {
                            viewAiPane = d;
                          }
                        }
                        return d;
                      });
                    }
                    return c;
                  });
                  dispatch({
                    type: CAction.BOARD_REORDER_COLUMN,
                    columns,
                    viewAiPane,
                    boardTimeline: timelineData,
                  });
                }
              });
          } else {
            if (removedItem != null) {
              if (oldColumnId == '1' && newColumnId != '1') {
                timelineData = removeTimelineTask(currentState, removedItem.id);
              } else if (oldColumnId != '1' && newColumnId == '1') {
                timelineData = updateTimleineTask(currentState, removedItem);
              }
            }
            if (timelineData != null) {
              dispatch({
                type: CAction.BOARD_UPDATE_TIMELINE,
                boardTimeline: timelineData,
              });
            }
            boardSevice.saveAIState({ act_id: itemId, state: destination.droppableId, tagId });
          }
        } else {
          boardSevice
            .changeColumn({
              itemId,
              boardType: board.type,
              newColumn: destination.droppableId,
              oldColumn: source.droppableId,
              boardId: board.id,
            })
            .then((response) => {
              const responseData = response.data.response;
              if (board.type == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
                const wsData: any = constructWsAutomationData(responseData);
                if (Object.keys(wsData).length) {
                  columns = columns.map((c: any) => {
                    if (c.id == newColumnId) {
                      c.data = c.data.map((d: any) => ({ ...d, ...wsData }));
                    }
                    return c;
                  });
                }
              } else if (board.type == BoardConst.BOARD_DATATYPE_PEOPLE) {
                const userData: any = constructUserAutomationData(responseData);
                if (Object.keys(userData).length) {
                  columns = columns.map((c: any) => {
                    if (c.id == newColumnId) {
                      c.data = c.data.map((d: any) => mergeUserAutomationData(d, userData));
                    }
                    return c;
                  });
                }
              }
              if (
                board.type == BoardConst.BOARD_DATATYPE_WORKSTREAMS ||
                board.type == BoardConst.BOARD_DATATYPE_PEOPLE
              ) {
                dispatch({
                  type: CAction.BOARD_REORDER_COLUMN,
                  columns,
                });
              }
            });
        }
      }
    } catch (e) {}
  };

export const updateColumnAutomationData =
  (columnId: string, isAutomationExist: boolean, data: any) =>
  (dispatch: Dispatch<CAction.ColumnActionTypes>, getState: any) => {
    try {
      const currentState = getState();
      let { boardDetails, boardTimeline } = getState();
      const { board = {}, tagId, boardType, columns } = boardDetails;
      if (Object.keys(board).length) {
        const bType = board.type;
        if (bType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
          boardDetails.columns = boardDetails.columns.map((c: any) => {
            if (c.id == columnId) {
              c.isAutomationExist = isAutomationExist;
            }
            if (Object.keys(data).length) {
              c.data = c.data.map((cd: any) => ({ ...cd, ...data }));
            }
            return c;
          });
        } else if (bType == BoardConst.BOARD_DATATYPE_PEOPLE) {
          boardDetails.columns = boardDetails.columns.map((c: any) => {
            if (c.id == columnId) {
              c.isAutomationExist = isAutomationExist;
            }
            if (Object.keys(data).length) {
              c.data = c.data.map((cd: any) => mergeUserAutomationData(cd, data));
            }
            return c;
          });
        }
      } else if (Object.keys(columns).length) {
        const removeTasks: any = [];
        boardDetails.columns = boardDetails.columns.map((c: any) => {
          if (c.id == columnId) {
            c.isAutomationExist = isAutomationExist;
            if (Object.keys(data).length) {
              c.data = c.data.map((cd: any) => {
                let processingTask = false;
                const typeId = `type_${cd.type}`;
                if (typeof data?.[typeId]?.state !== undefined) {
                  if (cd.state == '1' && data[typeId].state != '1') {
                    processingTask = true;
                    removeTasks.push(cd.id);
                  } else if (!processingTask && cd.state != '1' && data[typeId].state == '1') {
                    processingTask = true;
                    boardTimeline = updateTimleineTask(currentState, cd);
                  }
                }
                if (typeof data.owner !== undefined) {
                  if (data.owner != cd.onwer && cd.state == '1' && !processingTask) {
                    boardTimeline = updateTimleineTask(currentState, cd, cd.owner);
                  }
                }
                console.log('typeId', typeId);
                const { type_0, type_1, type_2, ...resetData } = data;
                ACTIVITY_TYPE_ATTR_NAMES.forEach((attrName) => {
                  if (data?.[typeId]?.[attrName]) {
                    resetData[attrName] = data[typeId][attrName].value;
                  }
                });
                console.log('resetData', resetData);
                return mergeAiAutomationData(cd, resetData);
              });
            }
          }
          return c;
        });
        if (removeTasks.length) {
          boardTimeline = removeTimelineTask(currentState, removeTasks);
        }
      }
      dispatch({
        type: CAction.BOARD_MERGE_AUTOMATION,
        boardDetails,
        boardTimeline,
      });
    } catch (e) {}
  };

export const updateBoardTimeline = (data: any) => (dispatch: Dispatch<CAction.ColumnActionTypes>, getState: any) => {
  try {
    const { boardTimeline } = getState();
    if (Object.keys(data).length) {
      const { source, val } = data;
      if (source == 'start_date') {
        boardTimeline.start_date = val ? new Date(val).getTime() / 1000 : null;
      } else if (source == 'end_date') {
        boardTimeline.end_date = val ? new Date(val).getTime() / 1000 : null;
      }
      dispatch({
        type: CAction.BOARD_UPDATE_TIMELINE,
        boardTimeline,
      });
    }
  } catch (e) {}
};
